import { ITEM_TYPES } from '../types/ItemTypes';
var WIX_DATA_PAGE_ITEM = ITEM_TYPES.WIX_DATA_PAGE_ITEM;
function getWixDataPageId(customItemType) {
    if (customItemType.startsWith(WIX_DATA_PAGE_ITEM)) {
        var _a = customItemType.split('-'), pageId = _a[1];
        return pageId;
    }
    return undefined;
}
export function getWixDataUserPatternsByPageId(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.userPatterns, userPatterns = _c === void 0 ? [] : _c, _d = _b.options, _e = _d === void 0 ? {} : _d, _f = _e.logError, logError = _f === void 0 ? function () { } : _f;
    try {
        var predicate_1 = function (_a) {
            var patternType = _a.patternType;
            return patternType.startsWith(WIX_DATA_PAGE_ITEM);
        };
        return userPatterns.reduce(function (previousValue, currentValue) {
            if (predicate_1(currentValue)) {
                var patternType = currentValue.patternType, content = currentValue.content;
                var pageId = getWixDataPageId(patternType);
                if (pageId) {
                    previousValue[pageId] =
                        typeof content === 'string' ? JSON.parse(content) : content;
                }
            }
            return previousValue;
        }, {});
    }
    catch (error) {
        logError({ error: error, data: { value: userPatterns } });
        return {};
    }
}
